<template>
    <div class="lx-online-booking-checkout-complete-booking">
        <card :body-class="['bg-primary', 'text-light']">
            <template #header-icon>
                <font-awesome-icon
                    :icon="['fas', 'circle-check']"
                    size="lg"
                />
            </template>
            <template #header-content>
                Complete Booking
            </template>
            <template #body>
                <online-booking-checkout-complete-booking
                    :invalid="invalid"
                    :fields="fields"
                    :button-variant="'light'"
                />
            </template>
        </card>
    </div>
</template>

<script>
    import Card from '../../../generic/card/card.vue';
    import OnlineBookingCheckoutCompleteBooking from '../common/online-booking-checkout-complete-booking.vue';

    export default {
        name: 'OnlineBookingCheckoutCompleteBookingCard',
        components: {
            Card,
            OnlineBookingCheckoutCompleteBooking,
        },
        props: {
            invalid: {
                type: Boolean,
                default: false,
            },
            fields: {
                type: Object,
                default: () => ({})
            }
        },
    };
</script>

<style lang="scss" scoped>
</style>
